import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useConversationsSummaryDialogStyles = makeStyles({
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    errorMessage: {
        color: 'var(--colorStatusDangerForeground1)',
    },
    contentContainer: {
        maxHeight: '600px',
        overflowY: 'auto',
        ...shorthands.padding('8px'),
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '20px'
    },
    metricsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridAutoRows: 'minmax(90px, auto)',
        gap: '12px',
    },
    metricCard: {
        boxShadow: tokens.shadow4,
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        display: 'flex',
        flexDirection: 'column',
    },
    metricValue: {
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorBrandForeground1,
    },
    section: {
        ...shorthands.margin('0'),
    },
    tablesContainer: {
        display: 'flex',
        gap: '16px',
        alignItems: 'flex-start',
        ...shorthands.margin('0'),
    },
    tableSection: {
        flex: '1 1 0',
        minWidth: '0',
        display: 'flex',
        flexDirection: 'column',
    },
    tableWrapper: {
        display: 'flex',
        flexDirection: 'column',
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
        borderRadius: tokens.borderRadiusLarge,
        overflowY: 'auto',
        maxHeight: '250px',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px',
    },
    sectionIcon: {
        display: 'flex',
        alignItems: 'center',
        color: tokens.colorBrandForeground1,
    },
    sectionTitle: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: '8px',
        color: tokens.colorNeutralForeground1,
    },
    dataGrid: {
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    },
    tagContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
    },
    summaryCard: {
        ...shorthands.padding('12px'),
        backgroundColor: tokens.colorNeutralBackground2,
    },
    summaryText: {
        ...shorthands.margin('0'),
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        lineHeight: '1.5',
    },
    metricItem: {
        ...shorthands.margin('0 0 12px 0'),
    },
    label: {
        fontWeight: 600,
        marginRight: '4px',
    },
    listContainer: {
        ...shorthands.margin('4px 0 0 0'),
        ...shorthands.padding('0 0 0 20px'),
        '& li': {
            marginBottom: '4px',
        },
    },
    summaryHeader: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        alignItems: 'stretch',
        gap: '12px',
    },
    totalCard: {
        boxShadow: tokens.shadow8,
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    },
    totalCardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ...shorthands.padding('12px'),
        textAlign: 'center',
    },
    tabPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingTop: '12px',
    },
    totalCardValue: {
        fontSize: tokens.fontSizeHero700,
        fontWeight: tokens.fontWeightBold,
        color: tokens.colorBrandForeground1,
        lineHeight: '1',
    },
    totalCardLabel: {
        fontSize: tokens.fontSizeBase300,
        color: tokens.colorNeutralForeground2,
        marginTop: '4px',
    },
    periodField: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
    },
});
